import {
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

type Props = {
  label: string;
  onPress: () => void;
  disabled?: boolean;
};

export const MenuOptionRow = ({ label, onPress, disabled = false }: Props) => (
  <Pressable
    onPress={() => {
      if (!disabled) {
        onPress();
      }
    }}
    disabled={disabled}
    accessibilityState={{ disabled }}
  >
    <HStack
      alignItems="center"
      paddingHorizontal={4}
      paddingVertical={3}
      backgroundColor="surface-primary"
    >
      <Text
        variant="mainBaseSemiBold"
        color={disabled ? "text-disabled" : "text-primary"}
      >
        {label}
      </Text>
    </HStack>
  </Pressable>
);
